<template>
  <div>
    <BaseFrame>
      <div slot="content">
        <div class="mb16">
          <lk-card title="一级区域">
            <lk-row :gutter="16">
              <div class="btns">
                <lk-button style="margin-bottom: 10px;" type='primary' @click="fatherCreate" v-if="handlePermission('addZone')">新建一级区域</lk-button>
              </div>
              <lk-table
              border
              :columns="fatherColumns"
              :data="fatherData">
            </lk-table>
            </lk-row>
          </lk-card>
        </div>
        <div class="mb16">
          <lk-card class="clear" title="二级区域">
            <lk-row :gutter="16">
              <lk-button style="margin-bottom: 10px;" type='primary' @click="sonCreate" v-if="handlePermission('addZone')">新建二级区域</lk-button>
              <lk-table
                border
                :columns="sonColumns"
                :data="sonData">
              </lk-table>
              <lk-Page
                class="pages"
                show-sizer
                show-elevator
                show-total
                @on-page-size-change="handlePageSize"
                @on-change="handlePage"
                :total="count"
                :current="page"
                :page-size-opts="[10,20,50]">
              </lk-Page>
            </lk-row>
          </lk-card>
        </div>
      </div>
    </BaseFrame>
    <lk-modal :title="editFather ? '编辑' : '新建一级区域'"
    v-model="showFatherModal"
    :footer-hide='true'
    width="410"
    @on-cancel="showFatherModal = false; father.fatherName='';editFather=false">
      <div class="container">
        <lk-form :label-width="83" :model="father" :rules='fatherValidate'>
          <lk-form-item label="区域名称：" prop="fatherName">
            <lk-input :maxlength='32' placeholder='请输入' v-model="father.fatherName"></lk-input>
          </lk-form-item>
        </lk-form>
      </div>
      <div class="bottomButton">
          <lk-button type='primary' :disabled="father.fatherName == ''" @click="addFather">确认</lk-button>
          <lk-button @click="showFatherModal = false; father.fatherName='';editFather=false">取消</lk-button>
      </div>
    </lk-modal>
    <lk-modal :title="editSon ? '编辑' : '新建二级区域'" v-model="showSonModal" :footer-hide='true' width="410" @on-cancel="cancelSon">
      <div class="container">
        <lk-form :label-width="83" :model="son" :rules='sonValidate'>
          <lk-form-item label="区域名称：" prop="sonName">
            <lk-input :maxlength='32' placeholder='请输入' v-model="son.sonName"></lk-input>
          </lk-form-item>
          <lk-form-item label="上级区域：" prop="upZone">
            <lk-select class="item" filterable clearable v-model="son.upZone">
              <lk-option
                v-for="item in fatherData"
                :value="item.id"
                :key="item.id">{{ item.name }}</lk-option>
            </lk-select>
          </lk-form-item>
          <lk-form-item label="管理省份：" prop="province">
            <lk-select class="item" filterable clearable :multiple="true" v-model="son.province">
              <lk-option
                v-for="item in upZoneList"
                :value="item.id"
                :key="item.id"
                :disabled="item.status == 2">{{ item.name }}</lk-option>
            </lk-select>
          </lk-form-item>
        </lk-form>
      </div>
      <div class="bottomButton">
          <lk-button type='primary' :disabled="sonDisable" @click="addSon">确认</lk-button>
          <lk-button @click="cancelSon">取消</lk-button>
      </div>
    </lk-modal>
    <lk-modal title="提示" v-model="warnModal" :footer-hide='true' width="410">
      <div style="display:flex; margin-left: 10px;">
        <span class="warnIcon iconfont">&#xe613;</span><div style="margin-top: 6px;"> 确认是否删除？</div>
      </div>
      <div class="bottomButton">
          <lk-button type='primary' @click="deleteZone(deleteId)">确认</lk-button>
          <lk-button @click="warnModal = false;">取消</lk-button>
      </div>
    </lk-modal>
  </div>
</template>
<script>
import BaseFrame from '../../components/frame/BaseFrame.vue';
import inventory from '../../services/inventory';
import mapState from '../../mixins/mapState'; // 鉴权
import queryMixins from '../../mixins/queryMixins';
import utils from '../../libs/utils';
import tools from '../../services/tools';
import system from '../../services/system';

export default {
  name: 'branchInfo',
  mixins: [mapState, queryMixins],
  components: {
    BaseFrame,
  },
  computed: {
    sonDisable() {
      return this.son.sonName == '' || this.son.upZone == [] || this.son.upZone == undefined || this.son.upZone == '';
    },
  },
  data() {
    return {
      warnModal: false,
      editFather: false,
      editSon: false,
      deleteId: '',
      sonData: [],
      fatherData: [],
      father: {
        fatherName: '',
      },
      showFatherModal: false,
      fatherValidate: {
        fatherName: [
          {
            required: true,
            message: '请输入区域名称',
            trigger: 'blur',
          },
        ],
      },
      son: {
        sonName: '',
        upZone: '',
        province: [],
      },
      showSonModal: false,
      sonValidate: {
        sonName: [
          {
            required: true,
            message: '请输入区域名称',
            trigger: 'blur',
          },
        ],
        upZone: [
          {
            required: true,
            message: '请选择上级区域',
            trigger: 'blur',
          },
        ],
        province: [
          {
            required: false,
            message: '请选择省份',
            trigger: 'blur',
          },
        ],
      },
      upZoneList: [],
      fatherColumns: [
        {
          title: '序号',
          width: 60,
          render: (h, params) => h('span', params.index + 1),
        },
        {
          title: '一级区域名称',
          key: 'primaryRegionName',
          minWidth: 110,
        },
        {
          title: '所属二级区域',
          key: 'subSecondaryRegion',
          minWidth: 110,
        },
        {
          title: '最后编辑时间',
          key: 'modifiedTime',
          minWidth: 110,
          render: (h, params) => h('span', utils.formatTime(params.row.modifiedTime)),
        },
        {
          title: '操作人',
          key: 'modifiedUserName',
          minWidth: 110,
        },
        {
          title: '操作',
          minWidth: 200,
          render: (h, params) => h('div', [
            this.handlePermission('editZone') ? h('lk-button', {
              props: {
                type: 'text',
                size: 'small',
              },
              on: {
                click: () => {
                  this.editFather = true;
                  this.father.fatherName = params.row.primaryRegionName;
                  this.editId = params.row.id;
                  this.showFatherModal = true;
                },
              },
            }, '编辑') : '',
            this.handlePermission('deleteZone') ? h('lk-button', {
              props: {
                type: 'text',
                size: 'small',
              },
              on: {
                click: () => {
                  this.deleteId = params.row.id;
                  this.warnModal = true;
                },
              },
            }, '删除') : '',
          ]),
        },
      ],
      sonColumns: [
        {
          title: '序号',
          width: 60,
          render: (h, params) => h('span', params.index + (this.page - 1) * this.size + 1),
        },
        {
          title: '一级区域名称',
          key: 'primaryRegionName',
          minWidth: 110,
        },
        {
          title: '二级区域名称',
          key: 'secondaryRegionName',
          minWidth: 110,
        },
        {
          title: '所属省份',
          key: 'subProvince',
          minWidth: 110,
        },
        {
          title: '最后编辑时间',
          key: 'modifiedTime',
          minWidth: 110,
          render: (h, params) => h('span', utils.formatTime(params.row.modifiedTime)),
        },
        {
          title: '操作人',
          key: 'modifiedUserName',
          minWidth: 110,
        },
        {
          title: '操作',
          minWidth: 200,
          render: (h, params) => h('div', [
            this.handlePermission('editZone') ? h('lk-button', {
              props: {
                type: 'text',
                size: 'small',
              },
              on: {
                click: () => {
                  this.searchProvince(params.row.id);
                  this.editSon = true;
                  this.son.sonName = params.row.name;
                  this.son.province = params.row.regionIdList;
                  this.son.upZone = params.row.pid;
                  this.editId = params.row.id;
                  this.showSonModal = true;
                },
              },
            }, '编辑') : '',
            this.handlePermission('deleteZone') ? h('lk-button', {
              props: {
                type: 'text',
                size: 'small',
              },
              on: {
                click: () => {
                  this.deleteId = params.row.id;
                  this.warnModal = true;
                },
              },
            }, '删除') : '',
          ]),
        },
      ],
      page: 1,
      size: 10,
      count: 0,
    };
  },
  methods: {
    fatherCreate() {
      this.showFatherModal = true;
    },
    sonCreate() {
      this.showSonModal = true;
      this.searchProvince();
    },
    addFather() { // 新建一级
      if (this.editFather) {
        this.editFather = false;
        this.editZone({ name: this.father.fatherName, id: this.editId });
      } else {
        this.addZone({ name: this.father.fatherName });
      }
      this.showFatherModal = false;
    },
    addSon() { // 新建二级
      const params = {
        name: this.son.sonName,
        pid: this.son.upZone,
        id: this.editId,
        regionIdList: this.son.province,
      };
      if (this.editSon) {
        this.editSon = false;
        this.editZone(params);
      } else {
        this.addZone(params);
      }
      this.showSonModal = false;
    },
    cancelSon() {
      this.showSonModal = false;
      this.son.sonName = '';
      this.son.upZone = '';
      this.son.province = [];
      this.editSon = false;
    },
    getFatherList() {
      system.getFatherList().then((res) => {
        if (res.data.status === 200) {
          this.fatherData = res.data.data;
        } else {
          this.$Message.error(res.data.error);
        }
      }).catch((err) => {
        utils.handleError(err);
      });
    },
    getSonList() {
      system.getSonList({ page: this.page, size: this.size }).then((res) => {
        if (res.data.status === 200) {
          const { count, list } = res.data.data;
          this.count = count;
          this.sonData = list;
        } else {
          this.$Message.error(res.data.error);
        }
      }).catch((err) => {
        utils.handleError(err);
      });
    },
    deleteZone(id) {
      this.warnModal = false;
      system.deleteZone({ id }).then((res) => {
        if (res.data.status === 200) {
          this.$Message.success('删除成功');
          this.getFatherList();
          this.handlePage(1);
        } else {
          this.$Message.error(res.data.error);
        }
      }).catch((err) => {
        utils.handleError(err);
      });
    },
    searchProvince(id) {
      system.searchProvince({ id }).then((res) => {
        if (res.data.status === 200) {
          this.upZoneList = res.data.data;
        } else {
          this.$Message.error(res.data.error);
        }
      }).catch((err) => {
        utils.handleError(err);
      });
    },
    addZone(params) {
      system.addZone(params).then((res) => {
        if (res.data.status === 200) {
          this.$Message.success('添加成功');
          this.getFatherList();
          this.handlePage(1);
        } else {
          this.$Message.error(res.data.error);
        }
        this.clearTempInfo();
      }).catch((err) => {
        utils.handleError(err);
        this.clearTempInfo();
      });
    },
    editZone(params) {
      system.editZone(params).then((res) => {
        if (res.data.status === 200) {
          this.$Message.success('保存成功');
          this.getFatherList();
          this.handlePage(1);
        } else {
          this.$Message.error(res.data.error);
        }
        this.clearTempInfo();
      }).catch((err) => {
        utils.handleError(err);
        this.clearTempInfo();
      });
    },
    clearTempInfo() {
      this.cancelSon();
      this.father.fatherName = '';
    },
    handlePage(page) {
      this.page = page;
      this.getSonList();
    },
    handlePageSize(size) {
      this.size = size;
      this.page = 1;
      this.getSonList();
    },
  },
  created() {
    this.getFatherList();
    this.getSonList();
  },
};
</script>
<style lang="less" scoped>
  .pages{
    margin-top: 16px;
    text-align: right
  }
  .split-line {
    padding-bottom:6px;
    margin-bottom:6px;
    border-bottom: 1px solid #e9e9e9;
  }
  .leftMargin {
    left: 10px !important;
    margin-left: -80px !important;
  }
  .bottomButton{
    margin-left: 234px;
    margin-top: 20px;
    >*{margin-right: 16px
  }
}
.container {
  margin-left: 12px;
  margin-right: 15px;
}
.warnIcon {
  color: orange;
  font-size: 20px;
  margin-right: 6px;
};
</style>
